import auth from 'src/auth';
import {} from './servicesClient';
import { RenderingSDK, CoamResponseType } from '@rendering/web-client';

type PermissionEntry = {
    permissions: string[];
    identifier: string;
};

type MappedCoamResponse = Record<string, string[]>;

function extractResourceIdentifiers(permissionEntries: PermissionEntry[] = []): string[] {
    return permissionEntries
        .filter((value) => value.permissions.includes('create:scenes'))
        .map((value) => value.identifier);
}

function mapCoamResponse(coamResponse: CoamResponseType): MappedCoamResponse {
    const keys = Object.keys(coamResponse);

    const mappedCoamResponse: MappedCoamResponse = {};
    keys.forEach((key) => {
        const identifiers = extractResourceIdentifiers(coamResponse[key]);
        if (identifiers.length) {
            mappedCoamResponse[key] = identifiers;
        }
    });
    return mappedCoamResponse;
}

/**
 * Retrieves an array of merchants and fulfillers that the principal has access to.
 * @returns {object} - The promise of the request.
 */
export function getResources(sdk: RenderingSDK): Promise<MappedCoamResponse> {
    // eslint-disable-line import/prefer-default-export
    const { sub } = auth.getProfile();
    return sdk.Settings.getCOAMPermissions(sub).then((res) => mapCoamResponse(res));
}
